import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import _ from 'lodash';
import TicketResaleSection from './ticket-resale-section';
import { Provider } from 'react-redux';
import configureStore from '../../sso/store/configure-store';

class TicketResaleComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        const store = configureStore();
        
        ReactDOM.render(
            <Fragment>
                <Provider store={store}>
                    <TicketResaleSection
                        formData={this.options}
                    />
                </Provider>
            </Fragment>,
            this.element
        );
    }
}

export default TicketResaleComponent;

